import Player from 'src/entry_points/player';
import IFramePlayer from 'src/entry_points/iframe_player';
import { ConfigurationBuilder } from 'views/configuration';

export const EmbedPlayerFactory = {
    createPlayer: (options = {}) => {
        const { iframe, ...args } = options;

        if (iframe === 'false' || iframe === false) {
            const builder = new ConfigurationBuilder();
            const { overridesUrl } = options;

            return (
                builder
                    .generate(overridesUrl)
                    .then(remoteConfig => {
                        const { language, level, context } = args;
                        remoteConfig.overrides.state = remoteConfig.overrides.state || {};
                        remoteConfig.overrides.context = remoteConfig.overrides.context || {};
                        remoteConfig.overrides.variables = remoteConfig.overrides.variables || {};

                        if (language) {
                            remoteConfig.overrides.state.language = language;
                        }
                        
                        if (level) {
                            remoteConfig.overrides.state.level = level;
                        }

                        if (context) {
                            remoteConfig.overrides.context = {
                                ...remoteConfig.overrides.context,
                                ...context
                            }

                            if(context?.user?.uid) {
                                remoteConfig.overrides.variables.respondentId = context?.user?.uid;
                                remoteConfig.overrides.analytics = remoteConfig.overrides.analytics || {};
                                remoteConfig.overrides.analytics.user = {
                                    ...context.user
                                };
                                remoteConfig.overrides.analytics.provider = {
                                    name: 'EmbedContextIdProvider'
                                };
                            }

                            if (context?.content?.cid) {
                                remoteConfig.overrides.variables.contentId = context?.content?.cid;
                            }
                        }

                        return new Player({
                            ...args,
                            ...remoteConfig
                        })
                    })
            )
        }

        return Promise.resolve(
            new IFramePlayer(args)
        )
    }
}